var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isWebComponentReady)?_c('nomad-chat',{key:_vm.chatKey,ref:"chatRef",class:[_vm.isNewChatOpen && 'new-chat__open'],attrs:{"target-group":_vm.targetGroup || '',"is-open":_vm.isNewChatOpen ? 'open' : ''}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }